module.exports = __webpack_public_path__ + "static/media/izlozba (10).551168c7.jpg";